import { createStore } from "jotai";
import { QueryClient } from "@tanstack/react-query";

// Export all atoms and actions
export * from "./atoms";
export * from "./actions";

// Export config
export * from "./config";

// Create store instance
export const store = createStore();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: true,
    },
  },
});
